import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from '../../../../Containers/Config';
import { Constant } from '../../../../Containers/Helpers/constant';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { DOWNLOAD_VOUCHERS, DOWNLOAD_VOUCHERS_ERROR, DOWNLOAD_VOUCHERS_SUCCESS } from '../../actionType';

function* getDownloadVouchers({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweMarketPlaceUrl}/v1/client/admin/download-vouchers`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: DOWNLOAD_VOUCHERS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: DOWNLOAD_VOUCHERS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_VOUCHERS_ERROR, payload: error });
  }
}

export function* watchGetDownloadVouchers() {
  yield takeEvery(DOWNLOAD_VOUCHERS, getDownloadVouchers);
}

function* getDownloadVouchersSaga() {
  yield all([fork(watchGetDownloadVouchers)]);
}

export default getDownloadVouchersSaga;
